module.exports = __webpack_public_path__ + "static/media/no-profile-picture.91892f11.jpg";